export default __webpack_public_path__ + "static/media/PrintCheque.90fbeada.svg";